import React, { useState, useRef } from 'react';
import { Dialog, Button, Form, Input, Layout, Notification, Loading, Select } from 'element-react';
import { useTranslation } from 'react-i18next';

import checkIcon from '../assets/imgs/check-icon-red.png'; 
import bainubLogo from '../assets/imgs/bainub_logo.png';

import sendEmailTemplate from '../graphql/lambdaInvokes';

function ContactSalesModal({ visible, onClose, planType }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);
  
  // --- ESTADO DEL FORMULARIO ACTUALIZADO ---
  const [form, setForm] = useState({
    fullName: '',
    companyName: '',
    email: '',
    phone: '', 
    billingPreference: '' 
  });
  const formRef = useRef(null);

  const pricingTextOptions = {
   Premium: {
     annual: "Annual - $3,995 MXN x 12",
     monthly: "Monthly - $3,495 MXN"
   },
   Enterprise: {
      annual: "Annual - $6,355 MXN x 12",
      monthly: "Monthly - $7,495 MXN"
    },
   default: {
     annual: "Annual Billing",
     monthly: "Monthly Billing"
   }
  };

  const planFeatures = {
    Premium: [
      "Buying and Selling Tools enabled",
      "Create your Company Microsite",
      "Message Center for Instant Communication",
      "Create up to 25 Product Ads",
      "Issue Trade Agreements",
      "Access to RFQ's",
      "List as a Premium Company",
      "Priority Advertising",
      "Bainub Assist ready to help"
    ],
    Enterprise: [
      "Buying and Selling Tools enabled",
      "Create your Company Microsite",
      "Message Center for Instant Communication",
      "Create up to 100 Product Ads!",
      "Issue Trade unlimited Agreements",
      "Access to RFQ's",
      "List as a Premium Company",
      "Targeted Advertising",
      "Bainub Assist unlimited",
      "Analytics",
      "5 seller accounts"
    ],
    default: [] 
  };

  const currentPricing = pricingTextOptions[planType] || pricingTextOptions.default;
  const currentFeatures = planFeatures[planType] || planFeatures.default;

  const onFormChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  // --- REGLAS DE VALIDACIÓN ---
  const rules = {
    fullName: [
      { required: true, message: 'This field is mandatory', trigger: 'blur' },
      { min: 3, message: 'Name must be at least 3 characters', trigger: 'blur' },
      { pattern: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s'-]+$/, message: 'Please enter a valid name (letters only)', trigger: 'blur' }
    ],
    companyName: [ 
      { required: true, message: 'This field is mandatory', trigger: 'blur' },
      { min: 3, message: 'Company name must be at least 3 characters', trigger: 'blur' }     
    ],
    email: [
      { required: true, message: 'This field is mandatory', trigger: 'blur' },
      { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
    ],
    phone: [ 
      { required: true, message: 'This field is mandatory', trigger: 'blur' },
      // Asegura que solo sean números
      { pattern: /^[0-9]+$/, message: 'Please enter digits only', trigger: 'blur' },
      // Mínimo de 10 dígitos 
      { min: 10, message: 'Phone number must be at least 10 digits', trigger: 'blur' }
    ],
    billingPreference: [ 
      { required: true, message: 'Please select a preference', trigger: 'change' }
    ]
  };

  // --- LÓGICA DE LIMPIEZA ---
  const clearForm = () => {
    setForm({
      fullName: '',
      companyName: '',
      email: '',
      phone: '',
      billingPreference: ''
    });
    if (formRef.current) {
      formRef.current.resetFields();
    }
  };

  const handleSubmit = () => {
    formRef.current.validate(async (valid) => {
      if (valid) {
        setLoading(true);
        console.log(`Enviando formulario para ${planType}:`, form);

        try {
          await sendEmailTemplate({
            templateName: "form", 
            subject: `FORMULARIO - ${planType ? planType.toUpperCase() : ''} PLAN QUOTATION`,
            recipients: [ "customerservice@bainub.com" ], 
            templateVars: {
            content: `Plan: ${planType}<br/>
                          Full Name: ${form.fullName}<br/>
                          Company Name: ${form.companyName}<br/>
                          Email: ${form.email}<br/>
                          Phone: ${form.phone}<br/>
                          Billing Preference: ${form.billingPreference}<br/>
                          Date: ${new Date().toLocaleString()}
                          `
                        },
                        templateLanguage: "en"
                      });
          
          setLoading(false);
          setIsSubmitted(true);

            } catch (e) {
            // --- AÑADE ESTA LÓGICA DE ERROR ---
            setLoading(false);
            console.error("Error al enviar el formulario:", e);
            Notification({
            title: 'Error',
            message: 'There was a problem sending your form. Please try again.',
            type: 'error',
            offset: 100
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    };

  const handleClose = () => {
    clearForm(); 
    setIsSubmitted(false)
    onClose();   
  };

  return (
    <Dialog
      visible={visible}
      onCancel={handleClose}
      size="large"
      className="sales-modal"
    >
      
      <Dialog.Body>
        <div className="custom-modal-header">
          <img src={bainubLogo} alt="Bainub" className="modal-logo" />
          <Button 
            type="text" 
            className="modal-close-button" 
            onClick={handleClose} 
          >
            <i className="el-icon-close"></i>
          </Button>
        </div>

        <Loading loading={loading}/>

        {
        !isSubmitted ? (        
          <Layout.Row gutter="30">  
            {/* --- Columna Izquierda --- */}
            <Layout.Col sm="24" md="12">
              <div className="modal-text-content">
                <h1 className="modal-title">
                  JOIN {planType ? planType.toUpperCase() : ''} PLAN
                </h1>
                <h2 className="modal-subtitle">Share your information to join</h2>
                <p className="sales-rep-text">A sales representative will contact you soon.</p>
                <ul className="sales-modal-list">
                  {currentFeatures.map((feature, index) => (
                    <li key={index}>
                      <img src={checkIcon} alt="check"/> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </Layout.Col>

            {/* --- Columna Derecha (Formulario Actualizado) --- */}
            <Layout.Col sm="24" md="12">
              <Loading loading={loading}/>
              <Form ref={formRef} model={form} rules={rules}>
                <Form.Item label="Full Name:*" prop="fullName">
                   <Input value={form.fullName} onChange={(val) => onFormChange('fullName', val)} />
                </Form.Item>

            <Form.Item label="Company Name:*" prop="companyName">
                <Input value={form.companyName} onChange={(val) => onFormChange('companyName', val)} />
              </Form.Item>

                <Form.Item label="Corporate Email:*" prop="email">
                  <Input value={form.email} onChange={(val) => onFormChange('email', val)} />
                </Form.Item>

            {/* --- INICIA LA NUEVA FILA DE 2 COLUMNAS --- */}
            <Layout.Row gutter="20">
              
              {/* --- Columna de Teléfono --- */}
              <Layout.Col span="12">
                <Form.Item label="Phone:*" prop="phone">
                  <Input value={form.phone} onChange={(val) => onFormChange('phone', val)} />
                </Form.Item>
              </Layout.Col>

              {/* --- Columna de Billing Preference --- */}
              <Layout.Col span="12">
                <Form.Item label="Billing Preference:*" prop="billingPreference">
                    <Select 
                      value={form.billingPreference} 
                      placeholder="Select..." 
                      onChange={(val) => onFormChange('billingPreference', val)}
                      appendToBody={true}
                    >
                      <Select.Option label={currentPricing.annual} value="Annual"></Select.Option>
                      <Select.Option label={currentPricing.monthly} value="Monthly"></Select.Option>
                    </Select>
                </Form.Item>
              </Layout.Col>

            </Layout.Row>
                
                {/* --- BOTÓN ACTUALIZADO --- */}
                <Button type="primary" onClick={handleSubmit} loading={loading} className="send-button">
                  Request Plan Quotation
                </Button>

                <p className="privacy-text">
                  We will not share/sell your information. By submitting this form you confirm 
                  that you agree with our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> to receive Bainub mailing and 
                  information.
                </p>
              </Form>
            </Layout.Col>
          </Layout.Row>
        ) : (
          // --- VISTA DE ÉXITO ---
            <div className="success-message-container">
              <h1 className="success-title">REQUEST SUBMITTED</h1>
              <h2 className="success-subtitle">
                Thank you for you interest in 
                <img src={bainubLogo} alt="Bainub" className="logo-inline" />
              </h2>
            </div>
          )
        }
      </Dialog.Body>

      <Dialog.Footer>
        {/* --- 5. TEXTO DEL BOTÓN CONDICIONAL --- */}
        <Button onClick={handleClose} className="back-button">
          {!isSubmitted ? 'Back' : 'Return to Bainub'}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}

export default ContactSalesModal;